import { Divider, List } from "@mui/material";
import SidebarItem from "./SidebarItem";
import HomeIcon from "@mui/icons-material/Home";
import PhoneIcon from "@mui/icons-material/PhoneIphone"
import ProfileIcon from "@mui/icons-material/Person"
import { useTranslation } from "react-i18next";

interface Props {
  onClose?: () => void;
}

export default function Sidebar({ onClose }: Props) {
  const { t } = useTranslation();

  return (
    <List>
      <Divider/>
        <SidebarItem
          icon={<HomeIcon />}
          text={t("Dashboard")}
          to="/"
          onClick={onClose}
        />
      <Divider/>
        <SidebarItem
          icon={<PhoneIcon />}
          text={t("Applications")}
          to="/applications"
          onClick={onClose}
        />
      <Divider/>
        <SidebarItem
          icon={<ProfileIcon />}
          text={t("Profile")}
          to="/profile"
          onClick={onClose}
        />
      <Divider/>
    </List>
  );
}
